import React from 'react';
import UserMenu from './UserMenu.jsx';
import styles from "./navigation.css";
import defaultLogo from "./images/default-logo.png";

export default function Navigation({ appLogo, title, user }) {
  return (
    <div className={`${styles["eyesee-header"]} ${styles.navigation}`}>
      <div className={styles.logo}>
        <img src={appLogo || defaultLogo} alt={title || "Application logo"} />
      </div>

      <UserMenu user={user} />
    </div>
  )
}
